const cn: Record<string, string> = {
  create_new_lobby: "创建新大厅", // FrontPage — main CTA button
  join_lobby: "加入大厅", // FrontPage — join button
  switch_language: "中文", // FrontPage — language toggle button
  invalid_lobbyKey: "无效的大厅。如果意外发生，请在此处提交反馈:", // Lobby — error when lobby key is invalid
  host_is_configuring: "主持人正在配置游戏...", // Lobby — message shown to non-host players
  start_game: "开始游戏", // Lobby — host start button
  see_all: "查看全部结果", // MobileResults — show all results button
  you_did_not_answer: "你没有回答问题", // MobileResults — shown when player didn't submit
  set_your_name: "设置你的名字", // Lobby — name input prompt
  confirm: "确认", // Lobby — name confirm button
  recommendation: "我们建议使用真实姓名，但这不是必须的", // Lobby — name input hint
  thanks_for_playing: "感谢游玩", // EndPanel — end screen heading
  more_stuff: "更多内容即将推出", // EndPanel — end screen subheading
  knows_you_best: "最了解你的人: <h>{{bestPlayerName}}</h>", // EndPanel — best predictor stat
  best_accuracy: "预测准确率: <h>{{bestPlayerAccuracy}}%</h>", // EndPanel — best accuracy stat
  winner: "获胜者: <h>{{winnerName}}</h>", // EndPanel — winner announcement
  winning_score: "得分: <h>{{winnerScore}}</h>", // EndPanel — winner score
  knows_you_worst: "最不了解你的人: <h>{{worstPlayerName}}</h>", // EndPanel — worst predictor stat
  worst_accuracy: "预测准确率: <h>{{worstPlayerAccuracy}}%</h>", // EndPanel — worst accuracy stat
  attracted_to: "我喜欢", // Lobby — player config field
  provide_info:
    "是的，我愿意提供更多个人信息以提升游戏体验", // Lobby — player config opt-in
  my_age: "我的年龄", // Lobby — player config field
  player_config: "玩家配置", // Lobby — player config section heading
  your_answer: "你的回答:", // MobileResults — czar answer label
  did_not_answer: "你没有回答问题", // MobileResults — no-answer fallback
  you_scored: "你获得了 <h>{{score}}</h> 分!", // MobileResults — score display with points
  calculating_error: "扣分计算中: <h>-{{score}}</h>", // MobileResults — penalty animation text
  this_is_how_answered: "{{name}} 的回答是这样的", // MobileResults — other player's answer label
  lets_calculate: "来看看你预测得有多准...", // MobileResults — transition text before scoring
  player_submissons: "玩家提交", // MobileResults — section heading
  see_mine: "查看我的结果", // MobileResults — toggle to own results
  start_next_round: "开始下一轮", // MobileResults — host next round button
  waiting_next_round: "等待主持人", // MobileResults — non-host waiting text
  explain_decision: "能解释一下你的选择吗?", // MobileResults — czar explanation prompt
  czar_tier_perfect: "所有人都完美预测了你!", // MobileResults — tier message for czar
  czar_tier_great: "大家对你了解得太透彻了...", // MobileResults — tier message for czar
  czar_tier_good: "大家对你有相当准确的了解!", // MobileResults — tier message for czar
  czar_tier_average: "大家的预测还算不错...", // MobileResults — tier message for czar
  czar_tier_bad: "大家很难预测这道题", // MobileResults — tier message for czar
  czar_tier_terrible: "大家的想法和你完全相反", // MobileResults — tier message for czar
  czar_tier_perfect_duo: "{{name}} 完美预测了你!", // MobileResults — tier message (2-player)
  czar_tier_great_duo: "{{name}} 对你了解得太透彻了...", // MobileResults — tier message (2-player)
  czar_tier_good_duo: "{{name}} 对你有相当准确的了解!", // MobileResults — tier message (2-player)
  czar_tier_average_duo: "{{name}} 的预测还算不错...", // MobileResults — tier message (2-player)
  czar_tier_bad_duo: "{{name}} 很难预测这道题", // MobileResults — tier message (2-player)
  czar_tier_terrible_duo: "{{name}} 的想法和你完全相反", // MobileResults — tier message (2-player)
  czar_nobody_answered: "没有人提交预测", // MobileResults — no submissions fallback
  go_to_play: "开始游戏", // FrontPage — nav link
  go_to_how_to_play: "游戏说明", // FrontPage — nav link
  go_to_FAQ: "常见问题", // FrontPage — nav link
  submit: "提交", // SubmitButton — submit button text
  waiting: "等待中", // SubmitButton — waiting state text
  intro_for_tsar: "这一轮的主角是<h>你</h>!", // TurnBurst — burst headline for czar
  intro_about_tsar: "这一轮的主角是<h>{{tsar}}</h>!", // TurnBurst — burst headline for others
  burst_subtitle_tsar: "诚实作答", // TurnBurst — burst subtitle for czar
  burst_subtitle_other: "预测他们的排名", // TurnBurst — burst subtitle for others
  ftl_burst_headline_tsar: "你是领袖!", // TurnBurst — FTL burst for leader
  ftl_burst_subtitle_tsar: "其他人将尝试跟随你的选择", // TurnBurst — FTL subtitle for leader
  ftl_burst_headline_other: "Follow the Leader \u2014 跟上<h>{{tsar}}</h>!", // TurnBurst — FTL burst for followers
  ftl_burst_subtitle_other: "你的新领袖是 {{tsar}}。尽量跟上他们的脚步", // TurnBurst — FTL subtitle for followers
  ftl_still_running: "存活中", // FtlStatusBar — alive players heading
  ftl_graveyard: "淘汰区", // FtlStatusBar — eliminated players heading
  ftl_multiplier: "倍数", // FtlStatusBar — multiplier label
  ftl_leader_has_chosen: "领袖已做出选择!", // FtlReveal — reveal phase heading
  ftl_you_survived: "你存活了!", // FtlReveal — survival message
  ftl_you_were_eliminated: "已淘汰!", // FtlReveal — elimination message
  ftl_streak_results: "连胜结果", // FtlStreakResults — panel heading
  ftl_game_mode_label: "游戏模式", // Lobby — mode selector label
  ftl_standard: "标准", // Lobby — mode option
  ftl_follow_the_leader: "Follow the Leader", // Lobby — mode option
  // ─── Reverse Round ───────────────────────────────────────
  rr_burst_headline: "每个人的意见都很重要!", // TurnBurst — RR burst heading
  rr_burst_subtitle: "诚实作答 \u2014 按自己的方式排名", // TurnBurst — RR burst subtitle
  rr_guess_burst_headline: "<h>反转回合</h>", // TurnBurst — RR guess phase burst
  rr_guess_burst_subtitle: "猜猜这是谁的偏好", // TurnBurst — RR guess phase subtitle
  rr_stage1_header: "诚实作答", // ReverseRoundPanel — submission phase heading
  rr_stage2_header: "这是谁的排名?", // ReverseRoundPanel — guessing phase heading
  rr_high_roll_prompt: "想要更高风险的对决?", // ReverseRoundPanel — high roll prompt
  rr_high_roll_accept: "来吧，放手一搏", // ReverseRoundPanel — accept high roll button
  rr_high_roll_decline: "算了，不用了", // ReverseRoundPanel — decline high roll button
  rr_not_in_group: "不是其中任何一人", // ReverseRoundPanel — guess option
  rr_not_player: "不是 {{name}}", // ReverseRoundPanel — guess option
  rr_submitted_by: "由 {{name}} 提交", // ReverseRoundResults — sequence attribution
  rr_random_sequence: "随机序列", // ReverseRoundResults — random sequence label
  rr_shown_to: "展示给", // ReverseRoundResults — shown-to label
  rr_guessed_correctly: "猜对了", // ReverseRoundResults — correct guess label
  rr_thought_it_was: "认为是 {{name}}", // ReverseRoundResults — wrong guess label
  rr_mode_label: "反转回合", // Lobby — mode selector label
  rr_mode_description: "社交推理模式", // Lobby — mode selector description
  // ─── Run with the Herd ────────────────────────────────────
  herd_burst_headline: "<h>随大流!</h>", // TurnBurst — Herd burst heading
  herd_burst_subtitle: "选择多数人的选项 \u2014 否则就被踩踏!", // TurnBurst — Herd burst subtitle
  herd_still_running: "存活中", // HerdChoicePanel — alive label
  herd_trampled: "被踩踏", // HerdChoicePanel — eliminated label
  herd_you_survived: "你跟上了大多数!", // HerdChoicePanel — survival message
  herd_you_were_trampled: "被踩踏了!", // HerdChoicePanel — elimination message
  herd_split: "群体分裂!", // HerdStreakResults — split announcement
  herd_streak_results: "群体结果", // HerdStreakResults — panel heading
  herd_votes: "票", // HerdStreakResults — vote count label
  herd_game_mode_label: "Run with the Herd", // Lobby — mode selector label
  // ─── Picasso ────────────────────────────────────────────────
  picasso_burst_headline: "<h>毕加索时间!</h>", // TurnBurst — Picasso burst heading
  picasso_burst_subtitle: "画出你的答案 \u2014 让艺术说话!", // TurnBurst — Picasso burst subtitle
  picasso_gallery_burst_headline: "<h>画廊时间!</h>", // TurnBurst — gallery phase burst
  picasso_gallery_burst_subtitle: "这是谁画的? 快来猜猜!", // TurnBurst — gallery phase subtitle
  picasso_game_mode_label: "Picasso", // Lobby — mode selector label
  picasso_archive_which_real: "哪一幅是这局游戏画的?", // PicassoImposterReveal — archive mode question
  picasso_from_another_lobby: "来自其他大厅", // PicassoImposterReveal — archive label
  picasso_imposter_accept: "接受", // PicassoCanvas — accept impersonation button
  picasso_imposter_decline: "拒绝", // PicassoCanvas — decline impersonation button
  picasso_impersonating: "你正在冒充 {{name}}", // PicassoCanvas — impersonation status text
  // ─── Homepage / Community ───────────────────────────────────
  frontpage_tagline: "一款考验彼此了解程度的派对游戏", // FrontPage — hero tagline
  frontpage_explore_community: "探索社区", // FrontPage — community nav button
  frontpage_cta_title: "成为创作者", // FrontPage — creator CTA heading
  frontpage_cta_subtitle: "为游戏做贡献 \u2014 创建你自己的卡组", // FrontPage — creator CTA subtitle
  frontpage_create_deck: "创建卡组", // FrontPage — create deck button
  frontpage_profile: "个人资料", // FrontPage — profile nav link
  frontpage_login: "登录", // FrontPage — login button
  frontpage_logout: "退出登录", // FrontPage — logout button
  frontpage_community: "社区", // FrontPage — community nav link
  community_title: "社区", // CommunityPage — page heading
  community_tab_gallery: "画廊", // CommunityPage — tab label
  community_tab_analytics: "数据分析", // CommunityPage — tab label
  community_tab_leaderboard: "排行榜", // CommunityPage — tab label
  community_gallery_count: "{{count}} 幅画作及更多", // CommunityPage — drawing count
  community_gallery_empty: "暂无画作", // CommunityPage — empty state
  community_spotlight_close: "关闭", // CommunityPage — spotlight close button
  community_analytics_empty: "暂无分析数据。先来玩几局游戏吧!", // CommunityPage — empty state
  community_analytics_category: "分类", // CommunityPage — category selector label
  community_analytics_elo_title: "ELO排名", // CommunityPage — ELO section heading
  community_analytics_pca_title: "意见群体", // CommunityPage — PCA section heading
  community_analytics_pca_subtitle: "玩家偏好的聚类分布 \u2014 解释了 {{pc1}}% + {{pc2}}% 的方差", // CommunityPage — PCA description
  community_analytics_welcome: "玩家如何排名这些卡牌?", // CommunityPage — welcome heading
  community_analytics_welcome_sub: "探索各问题和分类的ELO排名及偏好模式。选择一个分类，再选择一个问题，即可查看玩家如何对答案卡进行排名。", // CommunityPage — welcome description
  community_insights_title: "有趣的发现", // CommunityPage — insights section heading
  community_insights_subtitle: "玩家排名背后的故事", // CommunityPage — insights description
  community_insight_divided: "大分歧", // CommunityPage — insight card title
  community_insight_consensus: "众口一词", // CommunityPage — insight card title
  community_insight_chaos: "完全混乱", // CommunityPage — insight card title
  community_insight_two_camps: "两大阵营", // CommunityPage — insight card title
  community_insight_players: "{{count}} 位玩家", // CommunityPage — player count label
  community_insight_see_full: "查看完整分析", // CommunityPage — link to analytics
  community_decks_title: "按卡组探索", // CommunityPage — decks section heading
  community_decks_subtitle: "有分析数据的卡组 \u2014 点击探索", // CommunityPage — decks section description
  community_decks_questions: "{{count}} 个问题", // CommunityPage — question count
  community_decks_categories: "{{count}} 个分类", // CommunityPage — category count
  community_deepdive_title: "深度挖掘", // CommunityPage — deep dive heading
  community_deepdive_subtitle: "浏览所有分类和问题", // CommunityPage — deep dive description
  round: "回合", // Timer — round counter label
  out_of: "/", // Timer — round counter separator
  wait_for_restart: "等待主持人重新开始", // EndPanel — non-host waiting text
  restart_lobby: "下一局游戏", // EndPanel — host restart button
  send: "发送", // FeedbackPage — send button
  feedback: "反馈:", // FeedbackPage — field label
  from: "来自:", // FeedbackPage — sender field label
  thx4Impro: "感谢你帮助改进 :)", // FeedbackPage — thank you message
  get_back: "现在回去继续玩吧", // FeedbackPage — return prompt
  give_feedback: "反馈", // Lobby — feedback button
  quickFeedBackQuestion: "<h>你</h>会如何改进这个游戏?", // ReportPanel — feedback question text
  quick_feedback: "快速反馈", // ReportPanel — feedback section heading
  skip: "跳过({{remainingSkips}})", // Game — skip button with remaining count
  card_deck_specs: "问题: {{questions}}\n答案: {{answers}}\n分类: {{categories}}", // CardDeckBrowser — tooltip with deck stats
  card_deck_specs_questions: "问题: {{questions}}", // CardDeckBrowser — question count
  card_deck_specs_answers: "答案: {{answers}}", // CardDeckBrowser — answer count
  card_deck_specs_categories: "分类: {{categories}}", // CardDeckBrowser — category count
  card_deck_specs_play: "场", // CardDeckBrowser — singular play count
  card_deck_specs_plays: "场", // CardDeckBrowser — plural play count
  card_deck_specs_language: "语言: {{language}}", // CardDeckBrowser — language label
  queue_title: "等候室", // QueuePage — page heading
  queue_position_of: "队列位置: {{position}} / {{total}}", // QueuePage — position indicator
  queue_membership_prompt: "有会员码? 输入即可跳过队列。", // QueuePage — code entry prompt
  queue_code_placeholder: "会员码", // QueuePage — code input placeholder
  queue_invalid_code: "无效的会员码", // QueuePage — error message
  queue_submit_code: "提交码", // QueuePage — submit button
  queue_leave: "离开队列", // QueuePage — leave button
  queue_timeout: "你的队列位置已过期，请重试。", // QueuePage — timeout message
  // ─── Profile / Creator Stats ───────────────────────────────
  global_rank: "全球排名", // ProfilePage — stat label
  language_rank: "语言排名", // ProfilePage — stat label
  total_plays: "共 {{count}} 次游玩", // ProfilePage — stat with count
  unique_players: "{{count}} 位独立玩家", // ProfilePage — stat with count
  out_of_creators: "{{total}} 位创作者中第 #{{rank}} 名", // ProfilePage — rank display
  no_play_data: "分享你的卡组以在此查看游戏统计", // ProfilePage — empty state
  name_taken: "已被占用", // ProfilePage — username validation
  name_saved: "已保存", // ProfilePage — save confirmation
  daily_plays_chart_title: "游玩次数", // ProfilePage — chart heading
  stats_7d: "7天", // ProfilePage — date range toggle
  stats_30d: "30天", // ProfilePage — date range toggle
  profile_dashboard: "仪表板", // ProfilePage — tab label
  profile_my_decks: "我的卡组", // ProfilePage — tab label
  profile_settings: "设置", // ProfilePage — tab label
  profile_top_decks: "表现最佳的卡组", // ProfilePage — section heading
  profile_search_decks: "搜索卡组...", // ProfilePage — search placeholder
  profile_bio_placeholder: "写一段简短的自我介绍...", // ProfilePage — bio textarea placeholder
  // ─── Leaderboard & Creator Profile ─────────────────────────
  leaderboard_title: "创作者排行榜", // LeaderboardPage — page heading
  leaderboard_back: "返回", // LeaderboardPage — back button
  leaderboard_global: "全球", // LeaderboardPage — tab label
  leaderboard_creator: "创作者", // LeaderboardPage — column header
  leaderboard_plays: "游玩次数", // LeaderboardPage — column header
  leaderboard_decks: "卡组", // LeaderboardPage — column header
  leaderboard_load_more: "加载更多", // LeaderboardPage — pagination button
  leaderboard_empty: "未找到创作者", // LeaderboardPage — empty state
  creator_not_found: "未找到创作者", // CreatorProfilePage — error state
  creator_back_to_leaderboard: "返回排行榜", // CreatorProfilePage — back button
  creator_no_decks: "该创作者暂无卡组", // CreatorProfilePage — empty state
  creator_decks_title: "{{count}} 个卡组", // CreatorProfilePage — section heading
  explainer_default: "每种颜色 = 一个排名", // ExplainerOverlay — default color legend
  explainer_high: "高评价 \u00b7 常排名第1", // ExplainerOverlay — high rank legend
  explainer_low: "低评价 \u00b7 常排名第5", // ExplainerOverlay — low rank legend
  // ─── Friend Pool ─────────────────────────────────────────────
  friend_pool_title: "关于彼此的问题", // Lobby — friend pool section heading
  friend_pool_add_placeholder: "添加朋友", // FriendPoolEditor — add friend input placeholder
  friend_pool_login_hint: "登录以保存你的朋友群组", // FriendPoolEditor — login prompt

  // ─── Old Lobby Config (GameConfigPanel) ────────────────────────
  game_config: "游戏配置", // GameConfigPanel — section heading
  game_mode: "游戏模式:", // GameConfigPanel — mode label
  speed: "速度:", // GameConfigPanel — speed label
  rounds: "回合:", // GameConfigPanel — rounds label
  family_friendly: "家庭友好", // GameConfigPanel — mode option
  party: "普通", // GameConfigPanel — mode option
  slow: "慢速 (推荐)", // GameConfigPanel — speed option
  medium: "中速", // GameConfigPanel — speed option
  fast: "快速", // GameConfigPanel — speed option
  one_round: "1", // GameConfigPanel — round option
  two_rounds: "2", // GameConfigPanel — round option
  three_rounds: "3 (推荐)", // GameConfigPanel — round option
  five_rounds: "5", // GameConfigPanel — round option

  // ─── FAQ / Bela ────────────────────────────────────────────────
  honorable_mention: "Honorable Mention", // FAQ — bela section heading
  bela_thanks:
    "I want to sincerly thank my friend Bela, who mentored this code project in his freetime and helped me with his expertise in programming, deployment and networking.", // FAQ — bela tribute text
  secret_admirer: "A secret admirer", // FeedbackPage — anonymous sender placeholder

  // ─── Bela Quotes (BelaQuote) ───────────────────────────────────
  bela_q_1: "Erweiterbarkeit, dies das",
  bela_q_2: "Das ist ja auch nicht schwer",
  bela_q_3: "Das wird dir beim deployment vermutlich um die ohren fliegen.",
  bela_q_4: "Ich würde ja rust empfehlen, aber du willst ja noch vor weihnachten fertig werden.",
  bela_q_5: "Ich würde immer noch das Backend abfackeln und neu bauen.",
  bela_q_6: "Du bist wie gesagt fernab von den Situationen, für die das designed wurde.",
  bela_q_7:
    "Mach dir halt keine Gedanken um Skalierung, wenn du keine Probleme mit Skalierung hast.",
  bela_q_8:
    "Ja, das ist halt ehrlich gesagt gerade die falsche Metrik.\nDas Ding wird umfallen, bei mehr Benutzern, dafür musst du es nicht testen.",
  bela_q_9: "Ja also das ist bescheidenes design",
  bela_q_10:
    "Das funktioniert super, solange du nur mit einer datenbank kommunizierst\naber genau in deinem fall bricht es halt auseinander",

  // ─── Deck Tutorial (DeckTutorial.tsx) ──────────────────────────
  deck_tutorial_hero_title: "How to Create a Card Deck",
  deck_tutorial_hero_subtitle: "Everything you need to know to build your own deck. It's easier than you think, and if formatting feels tricky, AI can do it for you.",
  deck_tutorial_what_is_deck: "What is a Deck?",
  deck_tutorial_what_is_deck_body: "A deck is a collection of questions and answers organized into categories. Categories group thematically related content together. When a turn starts, the game picks a category, then picks a question and 5 answers from it.",
  deck_tutorial_hierarchy_example: "Example structure:",
  deck_tutorial_min_cards_rule: "For the Standard game mode, each category needs at least 1 question and 5 answer cards to be playable. Other game modes like Picasso have different requirements (see below).",
  deck_tutorial_questions_title: "How Questions Work: The Two Sides",
  deck_tutorial_questions_body: "Every question has two versions: one addressed to \"you\" (for the tsar) and one using the tsar's name (for everyone else).",
  deck_tutorial_questions_why: "The tsar reads \"What would you do?\" while everyone else reads \"What would Sarah do?\" — so players can focus on predicting instead of rephrasing.",
  deck_tutorial_refresh_tsar: "Click to see how it looks with different tsar names",
  deck_tutorial_formatting_title: "Formatting: Highlights and the Tsar Name",
  deck_tutorial_formatting_body: "Two special formatting tools let you make cards look great in-game:",
  deck_tutorial_formatting_tip: "The editor has \"insert tsar name\" and \"highlight selection\" buttons that do this formatting for you. No need to type the tags manually.",
  deck_tutorial_ai_title: "Too Complicated? Let AI Do It.",
  deck_tutorial_ai_body: "Just type your question in plain text, something like \"what food would you never eat\", and press the magic wand button. AI will generate both the \"for the tsar\" and \"about the tsar\" versions with proper formatting. Works in any language!",
  deck_tutorial_ai_tip: "You can always edit the AI's output if you want to tweak it.",
  deck_tutorial_answers_title: "Answer Cards",
  deck_tutorial_answers_body: "Answer cards are simpler: just text, no special formatting needed. They're the options the tsar ranks. 5 answer cards from the same category are shown each turn. Keep them short and punchy.",
  deck_tutorial_friend_token_title: "Friend Names in Answer Cards",
  deck_tutorial_friend_token_body: "Want answer cards that use your friends' names? Use the {{friend}} token. At game time, it gets replaced with actual names from the player list. This lets you create personal, social questions without having to hardcode anyone's name.",
  deck_tutorial_friend_token_example_header: "How it works:",
  deck_tutorial_friend_token_example_card: "You write an answer card: {{friend}}",
  deck_tutorial_friend_token_example_resolve: "In-game, 5 copies appear — each showing a different player's name (e.g. Sarah, Max, Jordan, Alex, Riley)",
  deck_tutorial_friend_token_no_duplicate_title: "You only need to add it once!",
  deck_tutorial_friend_token_no_duplicate_body: "A single {{friend}} card automatically produces multiple unique answer cards at game time — one per friend. You don't need to add the same card twice. The game handles the duplication for you.",
  deck_tutorial_friend_token_button_tip: "Use the \"insert friend name\" button in the answer card editor to insert the {{friend}} token at the cursor position. The preview will show it with a random name so you can see how it looks.",
  deck_tutorial_skip_to_answers: "Skip to answer cards",
  deck_tutorial_nav_questions: "How to write questions",
  deck_tutorial_nav_answers: "How to write answers",
  deck_tutorial_nav_friend: "How to write questions about my friends",
  deck_tutorial_categories_title: "Categories: Grouping It All Together",
  deck_tutorial_categories_body: "Categories are tags that connect questions and answers. When a turn starts, the game picks a category, then picks a question and 5 answers from that category. That's why you need at least 5 answer cards per category for Standard mode.",
  deck_tutorial_categories_tip: "Make categories thematic (e.g., \"food\", \"relationships\", \"hypotheticals\"). This keeps the game coherent.",
  deck_tutorial_reuse_title: "Reusing cards across categories",
  deck_tutorial_reuse_body: "Here's a powerful feature: the same card can belong to multiple categories at once. When you assign categories to a card, you're not putting it in a box. You're tagging it. One answer card like \"Pizza\" could appear in a \"food\" category, a \"guilty pleasures\" category, and a \"first date\" category. Same card, different contexts.",
  deck_tutorial_reuse_example_header: "Example: one card, many categories",
  deck_tutorial_reuse_benefit: "This means you don't have to create the same card twice. Write it once, tag it with all the categories where it fits, and the game will use it in each of those contexts. The more categories a card belongs to, the more versatile your deck becomes.",
  deck_tutorial_picasso_title: "Bonus Mode: Picasso",
  deck_tutorial_picasso_body: "Picasso is a special bonus mode that the game triggers during a match. Instead of ranking pre-made answer cards, players draw their answers. Not every question works well as a drawing prompt, so you can mark individual questions as \"Picasso compatible\" when creating them.",
  deck_tutorial_picasso_checkbox: "\"Picasso compatible\" checkbox",
  deck_tutorial_picasso_checkbox_body: "When creating a question card, you'll see a checkbox labeled \"Picasso compatible\". Check this if the question works well as a drawing prompt. The game uses this to decide which questions can appear during Picasso rounds.",
  deck_tutorial_picasso_good_title: "Good Picasso questions (visual, creative, personal):",
  deck_tutorial_picasso_good_why: "These invite expressive, personal drawings where every player's answer will look completely different. That's what makes Picasso fun.",
  deck_tutorial_picasso_bad_title: "Bad Picasso questions (abstract, no drawing value):",
  deck_tutorial_picasso_bad_why: "\"What do you value most in a friend?\" is too abstract to draw. And \"What's your favorite ice cream flavor?\" has no real drawing value. Drawing a bowl of vanilla ice cream tells you no more than just writing the word \"vanilla\". Good Picasso questions should allow for expressive, unique answers that are genuinely more interesting as drawings than as text.",
  deck_tutorial_picasso_versatile_title: "Versatile questions work everywhere",
  deck_tutorial_picasso_versatile_body: "Some questions work great in both Standard and Picasso mode. For example, \"What does your happy place look like?\" can be answered by drawing it OR by ranking a list of options like Beach, Mountains, Home, Library, Park. If you write a question like this, check the Picasso box and also make sure the category has enough answer cards for Standard mode. That way the question gets used in both modes.",
  deck_tutorial_picasso_no_answers: "Picasso-only questions don't need answer cards. If a category only has Picasso-compatible questions and no answer cards, it will only appear during Picasso rounds. The game handles this automatically.",
  deck_tutorial_preview_title: "Preview & Polish",
  deck_tutorial_preview_body: "You can preview any card by clicking the Preview button. The preview shows exactly how the card will look in-game. Click the refresh icon to see it with different tsar names. Before leaving the editor, it warns you about incomplete categories.",
  deck_tutorial_cta_title: "Ready to create?",
  deck_tutorial_cta_button: "Go to My Profile",
  deck_tutorial_back_to_howto: "Back to How to Play",

  // ═══════════════════════════════════════════════════════════════
  // NEW KEYS — added for i18n coverage
  // ═══════════════════════════════════════════════════════════════

  // ─── Generic / shared ──────────────────────────────────────────
  back: "返回", // FeedbackPage, CardDeckBrowser — back button
  cancel: "取消", // CardDeckViewer — cancel button in report dialog
  close: "关闭", // CardDeckViewer — close button
  continue: "继续", // FtlStreakResults, HerdStreakResults, PicassoResults — host continue button
  accept: "接受", // PicassoCanvas — accept button
  decline: "拒绝", // PicassoCanvas — decline button
  dismiss: "关闭", // AdminMessageDialog, ShutdownDialog — dismiss button
  done: "完成", // CreateDeckConfigMenu — done button
  lock_in: "锁定", // SequenceBar — submit ranking button
  ready: "准备就绪", // MobileResults, FtlStreakResults, HerdStreakResults, PicassoResults — ready toggle
  unready: "取消准备", // EndPanel, MobileResults, FtlStreakResults, HerdStreakResults, PicassoResults — unready toggle
  report: "举报", // CardDeckViewer — report button
  submitted: "已提交", // PicassoCanvas — submission status
  waiting_for_host: "等待主持人...", // FtlStreakResults, HerdStreakResults, PicassoResults — non-host waiting
  waiting_for_others: "等待其他玩家...", // PicassoImposterReveal, ReverseRoundPanel — waiting message
  select_all: "全选", // CardDeckBrowser, TopicSelector — bulk select
  deselect_all: "取消全选", // CardDeckBrowser, TopicSelector — bulk deselect

  // ─── End Panel ─────────────────────────────────────────────────
  end_panel_review_game: "回顾完整游戏", // EndPanel — review game button
  end_panel_play_again: "再玩一次", // EndPanel — play again button

  // ─── FTL extras ────────────────────────────────────────────────
  ftl_leader: "领袖:", // FtlStreakResults — leader label

  // ─── Herd extras ───────────────────────────────────────────────
  herd_results: "群体结果", // HerdStreakResults — panel heading
  herd_trampled_spectating: "你被踩踏了。旁观中...", // HerdChoicePanel — spectating message
  herd_pick_majority: "选择多数人的选项!", // HerdChoicePanel — instruction text
  herd_locked_in: "已锁定。再次点击以更改...", // HerdChoicePanel — lock-in confirmation

  // ─── Picasso extras ────────────────────────────────────────────
  picasso_impersonate_prompt: "嘘！你能冒充", // PicassoCanvas — impersonation modal text
  picasso_eraser: "橡皮擦", // PicassoCanvas — eraser button
  picasso_unsubmit: "撤回提交", // PicassoCanvas — unsubmit button
  picasso_submit_drawing: "提交画作", // PicassoCanvas — submit drawing button
  picasso_which_true_answer: "谁的真实答案是", // PicassoImposterReveal — question heading
  picasso_confirm_vote: "确认投票", // PicassoImposterReveal — confirm vote button
  picasso_gallery: "画廊", // PicassoResults — gallery section heading
  picasso_impersonated: "已冒充", // PicassoResults — impersonation badge
  picasso_challenges: "挑战", // PicassoResults — challenges section heading

  // ─── Reverse Round extras ──────────────────────────────────────
  rr_whose_ranking: "这是谁的排名?", // ReverseRoundPanel — guess phase question
  rr_high_stakes_prompt: "想要更高风险的对决?", // ReverseRoundPanel — high roll prompt
  rr_roll_it: "来吧，放手一搏", // ReverseRoundPanel — accept high roll
  rr_nah: "算了，不用了", // ReverseRoundPanel — decline high roll

  // ─── Deck Browser ──────────────────────────────────────────────
  deck_browser_random: "随机", // CardDeckBrowser — random deck button
  deck_browser_deck: "卡组", // CardDeckBrowser — search mode toggle
  deck_browser_creator: "创作者", // CardDeckBrowser — search mode toggle
  deck_browser_languages: "语言", // CardDeckBrowser — language filter label
  deck_browser_create_deck: "创建卡组", // CardDeckBrowser — create deck button
  deck_browser_max_decks: "最多可选择 30 个卡组", // CardDeckBrowser — max selection warning

  // ─── Deck Viewer ───────────────────────────────────────────────
  deck_viewer_created_by: "创建者", // CardDeckViewer — creator label
  deck_viewer_questions: "问题", // CardDeckViewer — tab label
  deck_viewer_answers: "答案", // CardDeckViewer — tab label
  deck_viewer_for_tsar: "本人视角", // CardDeckViewer — sub-tab label
  deck_viewer_about_tsar: "他人视角", // CardDeckViewer — sub-tab label
  deck_viewer_report_deck: "举报卡组", // CardDeckViewer — report dialog title
  deck_viewer_report_why: "你为什么要举报这个卡组?", // CardDeckViewer — report dialog prompt
  deck_viewer_report_reason: "原因", // CardDeckViewer — report reason label
  deck_viewer_report_offensive: "冒犯性内容", // CardDeckViewer — report reason option
  deck_viewer_report_inappropriate: "不当内容", // CardDeckViewer — report reason option
  deck_viewer_report_spam: "垃圾内容", // CardDeckViewer — report reason option
  deck_viewer_report_low_quality: "低质量", // CardDeckViewer — report reason option
  deck_viewer_report_details: "附加说明 (可选)", // CardDeckViewer — report details field label
  deck_viewer_submit_report: "提交举报", // CardDeckViewer — submit report button

  leave: "离开", // Lobby — leave button

  // ─── Lobby UI ──────────────────────────────────────────────────
  lobby_players: "玩家", // Lobby — players panel heading
  lobby_invite: "邀请", // Lobby — invite button
  lobby_copied: "已复制！", // Lobby — invite button after copy
  lobby_by_topics: "按主题", // Lobby — deck selection mode toggle
  lobby_pick_decks: "选择牌组", // Lobby — deck selection mode toggle

  // ─── Lobby Tabs ────────────────────────────────────────────────
  lobby_tab_presets: "预设", // Lobby — right panel tab
  lobby_tab_questions: "问题", // Lobby — right panel tab
  lobby_tab_custom: "自定义", // Lobby — right panel tab

  // ─── Lobby Presets ─────────────────────────────────────────────
  lobby_preset_party: "派对", // LobbyPresetSelector — preset name
  lobby_preset_party_desc: "包含所有游戏模式，平衡性良好。", // LobbyPresetSelector — preset description
  lobby_preset_bonanza: "盛宴", // LobbyPresetSelector — preset name
  lobby_preset_bonanza_desc: "适合8人及以上。所有人都能持续参与行动。", // LobbyPresetSelector — preset description
  lobby_preset_duet: "二人行", // LobbyPresetSelector — preset name
  lobby_preset_duet_desc: "看看你们真正了解彼此多少。", // LobbyPresetSelector — preset description
  lobby_preset_picasso: "Picasso", // LobbyPresetSelector — preset name
  lobby_preset_picasso_desc: "全程绘画模式!", // LobbyPresetSelector — preset description

  // ─── Friend Pool extras ────────────────────────────────────────
  friend_pool_players: "玩家 (自动包含)", // FriendPoolEditor — auto-included players label
  friend_pool_extra: "额外朋友", // FriendPoolEditor — custom friends label

  // ─── Create Deck Config ────────────────────────────────────────
  config_link_created: "\u2713 链接已创建!", // CreateDeckConfigMenu — success message
  config_create_link_subtitle: "为这些卡组创建可分享的链接", // CreateDeckConfigMenu — subtitle
  config_your_name: "你的名字", // CreateDeckConfigMenu — name field label
  config_name_placeholder: "例如: 小明", // CreateDeckConfigMenu — name placeholder
  config_config_name: "配置名称", // CreateDeckConfigMenu — config name field label
  config_config_placeholder: "例如: 派对之夜", // CreateDeckConfigMenu — config name placeholder
  config_error_name: "请输入配置名称", // CreateDeckConfigMenu — validation error
  config_error_your_name: "请输入你的名字", // CreateDeckConfigMenu — validation error
  config_error_failed: "创建配置失败", // CreateDeckConfigMenu — API error
  config_create_link: "创建链接", // CreateDeckConfigMenu — create button

  // ─── Config Preview ────────────────────────────────────────────
  config_preview_not_found: "未找到配置", // ConfigPreviewPage — error
  config_preview_load_failed: "加载配置失败", // ConfigPreviewPage — error
  config_preview_lobby_failed: "创建大厅失败", // ConfigPreviewPage — error
  config_preview_game_failed: "启动游戏失败", // ConfigPreviewPage — error
  config_preview_invite_text: "邀请你体验特别版 rank.io", // ConfigPreviewPage — invite description
  config_preview_play_count: "人已游玩", // ConfigPreviewPage — play count label
  config_preview_decks_included: "包含的卡组:", // ConfigPreviewPage — section heading
  config_preview_and_more: "还有 {{count}} 个", // ConfigPreviewPage — overflow text
  config_preview_creating: "创建大厅中...", // ConfigPreviewPage — loading button text
  config_preview_play: "使用这些卡组游玩", // ConfigPreviewPage — play button text

  // ─── Topics ────────────────────────────────────────────────────
  topic_self_identity: "自我与身份", // TopicSelector via topics.ts — topic filter label
  topic_values_meaning: "价值观与意义", // TopicSelector via topics.ts — topic filter label
  topic_life_stories: "人生故事", // TopicSelector via topics.ts — topic filter label
  topic_hypotheticals: "假设情境", // TopicSelector via topics.ts — topic filter label
  topic_love_relationships: "爱情与关系", // TopicSelector via topics.ts — topic filter label
  topic_sex_intimacy: "性与亲密", // TopicSelector via topics.ts — topic filter label
  topic_social_friends: "社交与友谊", // TopicSelector via topics.ts — topic filter label
  topic_awkward_cringe: "尴尬时刻", // TopicSelector via topics.ts — topic filter label
  topic_food_drink: "饮食", // TopicSelector via topics.ts — topic filter label
  topic_sports_fitness: "运动与健身", // TopicSelector via topics.ts — topic filter label
  topic_music: "音乐", // TopicSelector via topics.ts — topic filter label
  topic_movies_tv_culture: "电影、电视与文化", // TopicSelector via topics.ts — topic filter label
  topic_lifestyle_style: "生活方式与风格", // TopicSelector via topics.ts — topic filter label
  topic_philosophy_ethics: "哲学与伦理", // TopicSelector via topics.ts — topic filter label
  topic_dark_uncomfortable: "黑暗与不适", // TopicSelector via topics.ts — topic filter label
  topic_politics_society: "政治与社会", // TopicSelector via topics.ts — topic filter label
  topic_career_ambition: "职业与抱负", // TopicSelector via topics.ts — topic filter label
  topic_games_gaming: "游戏", // TopicSelector via topics.ts — topic filter label
  topic_humor_absurd: "幽默与荒诞", // TopicSelector via topics.ts — topic filter label
  topic_travel_places: "旅行与地点", // TopicSelector via topics.ts — topic filter label
  topic_rank_friends: "给朋友排名", // TopicSelector via topics.ts — topic filter label
  topic_rank_friends_needs_pool: "打开好友名单并添加名字——这个主题排的就是名单里的人。", // TopicSelector — shown when the friends topic is picked but the friend pool is off
  topic_18_plus: "18+", // TopicSelector via topics.ts — topic filter label
  topic_low_quality: "低质量", // TopicSelector via topics.ts — topic filter label

  // ─── Card Creator ──────────────────────────────────────────────
  card_creator_question: "问题", // CardCreationWidget — card creation form
  card_creator_answer: "答案", // CardCreationWidget — card creation form
  card_creator_for_tsar: "本人视角", // CardCreationWidget — card creation form
  card_creator_about_tsar: "他人视角", // CardCreationWidget — card creation form
  card_creator_card_text: "卡牌文字", // CardCreationWidget — card creation form
  card_creator_tsar_tooltip: "沙皇是该回合的主角。", // CardCreationWidget — card creation form
  card_creator_insert: "插入", // CardCreationWidget — card creation form
  card_creator_tsar_name: "沙皇名字", // CardCreationWidget — card creation form
  card_creator_highlight_tooltip: "用于高亮沙皇的代词。", // CardCreationWidget — card creation form
  card_creator_highlight_selection: "高亮\n选中内容", // CardCreationWidget — card creation form
  card_creator_friend_tooltip: "插入 {{friend}} 标记。游戏中会替换为玩家/朋友的名字。", // CardCreationWidget — card creation form
  card_creator_friend_name: "朋友名字", // CardCreationWidget — card creation form
  card_creator_ai_tooltip: "用AI格式化 \u2014 自动生成「本人视角」和「他人视角」两个版本", // CardCreationWidget — card creation form
  card_creator_format_ai: "用AI格式化", // CardCreationWidget — card creation form
  card_creator_formatting: "格式化中...", // CardCreationWidget — card creation form
  card_creator_preview: "预览", // CardCreationWidget — card creation form
  card_creator_categories: "分类", // CardCreationWidget — card creation form
  card_creator_new_category: "新分类", // CardCreationWidget — card creation form
  card_creator_probability: "概率:", // CardCreationWidget — card creation form
  card_creator_picasso_compatible: "Picasso兼容", // CardCreationWidget — card creation form
  card_creator_add_card: "添加卡牌", // CardCreationWidget — card creation form
  card_creator_warn_highlight_title: "无法高亮答案卡的文字", // CardCreationWidget — warning props for CardWarning
  card_creator_warn_highlight_desc: "高亮功能仅适用于问题卡，用于突出显示沙皇的名字和代词。", // CardCreationWidget — warning props for CardWarning
  card_creator_warn_tsar_answer_title: "将沙皇名字插入答案卡?", // CardCreationWidget — warning props for CardWarning
  card_creator_warn_tsar_answer_desc: "在答案卡中插入沙皇名字不符合惯例，仅在特殊情况下使用。通常情况下，答案卡内容无需引用沙皇的名字。", // CardCreationWidget — warning props for CardWarning
  card_creator_warn_empty_for_title: "「本人视角」区域文字为空", // CardCreationWidget — warning props for CardWarning
  card_creator_warn_empty_for_desc: "问题卡两侧的文字均不能为空。", // CardCreationWidget — warning props for CardWarning
  card_creator_warn_empty_answer_title: "「答案」区域文字为空", // CardCreationWidget — warning props for CardWarning
  card_creator_warn_empty_answer_desc: "答案卡的文字不能为空。", // CardCreationWidget — warning props for CardWarning
  card_creator_warn_no_categories_title: "未选择分类", // CardCreationWidget — warning props for CardWarning
  card_creator_warn_no_categories_desc: "卡牌至少需要一个分类标签。", // CardCreationWidget — warning props for CardWarning
  card_creator_warn_duplicate_friend_title: "重复的 {{friend}} 卡牌", // CardCreationWidget — warning props for CardWarning
  card_creator_warn_duplicate_friend_desc: "这个分类中已有一张 {{friend}} 卡牌。单张 {{friend}} 卡牌在每轮中会自动替换为不同的朋友名字 \u2014 无需添加两次。", // CardCreationWidget — warning props for CardWarning
  card_creator_add_anyway: "仍然添加", // CardCreationWidget — card creation form
  card_creator_needs_formatting_title: "问题需要格式化", // CardCreationWidget — warning props for CardWarning
  card_creator_needs_formatting_about: "缺少「他人视角」版本。是否要用AI自动填充并格式化?", // CardCreationWidget — warning props for CardWarning
  card_creator_needs_formatting_general: "你的问题似乎没有格式化 \u2014 没有高亮代词或 {{tsar}} 标签。是否要用AI格式化?", // CardCreationWidget — warning props for CardWarning

  // ─── Card Warning ──────────────────────────────────────────────
  card_warning_do_not_show: "不再显示", // CardWarning — suppress checkbox
  card_warning_go_back: "返回", // CardWarning — back button
  card_warning_enable_anyway: "仍然启用", // CardWarning — override button

  // ─── Admin Message Dialog ──────────────────────────────────────
  admin_message_title: "来自管理员的消息", // AdminMessageDialog — dialog title
  admin_message_reply_placeholder: "回复管理员...", // AdminMessageDialog — reply input placeholder
  admin_message_reply_sent: "回复已发送!", // AdminMessageDialog — success message

  // ─── Shutdown Dialog ───────────────────────────────────────────
  shutdown_now: "立即", // ShutdownDialog — countdown final text
  shutdown_title: "计划维护", // ShutdownDialog — dialog title
  shutdown_message_placeholder: "给管理员留言...", // ShutdownDialog — message input placeholder
  shutdown_message_sent: "消息已发送!", // ShutdownDialog — success message

  // ─── Report Panel ──────────────────────────────────────────────
  report_panel_title: "评价 / 举报卡牌", // ReportPanel — panel heading

  // ─── Preview Card ──────────────────────────────────────────────
  preview_card_probability: "概率: ", // PreviewCard — probability tooltip prefix

  // ─── Join Page ─────────────────────────────────────────────────
  join_name: "名字", // JoinPage — name field label
  join_exit: "退出", // JoinPage — exit button

  // ─── Teasers ───────────────────────────────────────────────────
  leaderboard_teaser_title: "顶级创作者", // LeaderboardTeaser — section heading
  leaderboard_teaser_plays: "次游玩", // LeaderboardTeaser — play count unit
  leaderboard_teaser_empty: "创作者排行榜", // LeaderboardTeaser — empty state
  leaderboard_teaser_full: "完整排行榜", // LeaderboardTeaser — full leaderboard link
  analytics_teaser_title: "趋势", // AnalyticsTeaser — section heading
  analytics_teaser_desc: "ELO及玩家群体洞察", // AnalyticsTeaser — description
  analytics_teaser_explore: "探索分析", // AnalyticsTeaser — explore button
  gallery_teaser_title: "画廊", // GalleryTeaser — section heading
  gallery_teaser_desc: "查看玩家画作", // GalleryTeaser — description
  gallery_teaser_explore: "探索画廊", // GalleryTeaser — explore button
};

export default cn;
